import { render, staticRenderFns } from "./CatalogProductView.vue?vue&type=template&id=9273c32c&scoped=true&"
import script from "./CatalogProductView.vue?vue&type=script&lang=js&"
export * from "./CatalogProductView.vue?vue&type=script&lang=js&"
import style0 from "./CatalogProductView.vue?vue&type=style&index=0&id=9273c32c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9273c32c",
  null
  
)

export default component.exports